import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_approval_request_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  approval_sequence_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approver_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approver_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  approver_name: fromDatatype.VarcharDatatypeInterface;
  is_first_approval_level: boolean;
  approval_due_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_token: fromDatatype.VarcharDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  approver_action: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  approval_history_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_history_posting_status_remarks: fromDatatype.TextDatatypeInterface;
  approval_sequence_queue_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_queue_posting_status_remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_generic_doc_approval_request_RowClass implements bl_fi_generic_doc_approval_request_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  approval_sequence_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approver_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approver_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  approver_name: fromDatatype.VarcharDatatypeInterface;
  is_first_approval_level: boolean;
  approval_due_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_token: fromDatatype.VarcharDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  approver_action: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  approval_history_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_history_posting_status_remarks: fromDatatype.TextDatatypeInterface;
  approval_sequence_queue_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_queue_posting_status_remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
